module.exports = __webpack_public_path__ + "img/fledgling.166ff346.png";